import { FC } from "react";
import { Trans } from "react-i18next";
import styles from "./index.module.scss";

interface EmailConfirmationProps {
  email: string;
}

const EmailConfirmation: FC<EmailConfirmationProps> = ({ email }) => {
  return (
    <div className={styles.container}>
      <p className={styles.text}>
        <Trans i18nKey="pickup.successPage.emailConfirmation" values={{ email }}>
          <strong />
        </Trans>
      </p>
      <div className={styles.separator} />
    </div>
  );
};

export default EmailConfirmation;
